---
nb:
  market_prices:
    average: Snittpris
    avg_power_prices_year: Gjennomsnittlige kraftpriser i {year} [{currency_code}/MWh]
    heading: Markedspriser
    power_prices_year: Kraftpriser for {year}
    price_factor: Prisfaktor [%]
    realized_price: Oppnådd pris
    reservoir_fill:
      heading: Vannmagasin kapasitet
      y_axis_title: Fyllingsgrad
